// extracted by mini-css-extract-plugin
module.exports = {"menu":"Dropdown_menu__1evtn","menuItems":"Dropdown_menuItems__3I-aM","item":"Dropdown_item__3Ljs4","delete":"Dropdown_delete__pjg1a"};